import OT from '@opentok/client';

export default () => OT.hasEndToEndEncryptionSupport();
